import './shared/components/controllers/employeeEvent/1Controllers.js';
import './shared/components/controllers/employeeEvent/3Services.js';
import './shared/components/controllers/employeeEvent/employeeEventsDirective.js';
import './shared/components/controllers/IamAdminControllers.js';
import './shared/components/controllers/LanguageController.js';
import './shared/components/controllers/selfAccessRequest/1Controllers.js';
import './shared/components/controllers/selfAccessRequest/ConfirmRolesRequiringAdmAccountController.js';
import './shared/components/controllers/selfAccessRequest/ConfirmRolesRequiringAdmAccountItemController.js';
import './shared/components/controllers/selfAccessRequest/SelectSameAsController.js';
import './shared/components/controllers/systemOwner/1Controllers.js';
import './shared/components/controllers/systemOwner/SelectNewBackupSystemOwnerController.js';
import './shared/components/controllers/systemOwner/SelectNewPrimarySystemOwnerController.js';
import './shared/components/controllers/systemOwner/SystemOwnerCardDirective.js';
import './shared/components/controllers/topBar/TopBarControllers.js';
import './shared/components/directives/1Module.js';
import './shared/components/directives/autoHeightDirective.js';
import './shared/components/directives/businessUnitDirective.js';
import './shared/components/directives/businessUnitMemberDirective.js';
import './shared/components/directives/cardDirective.js';
import './shared/components/directives/confirmClickDirective.js';
import './shared/components/directives/employeeDirective.js';
import './shared/components/directives/employeeDirectiveMoreInfosController.js';
import './shared/components/directives/empStagingDirective.js';
import './shared/components/directives/empStagingMatchingArrivalController.js';
import './shared/components/directives/empStagingMatchingContractRenewalController.js';
import './shared/components/directives/empStagingMatchingController.js';
import './shared/components/directives/empStagingMatchingNewStatusController.js';
import './shared/components/directives/empStagingMatchingNewSupervisorController.js';
import './shared/components/directives/empStagingMatchingPropertiesController.js';
import './shared/components/directives/empStagingMatchingRehireController.js';
import './shared/components/directives/empStagingMatchingUpdatePendingPropertiesController.js';
import './shared/components/directives/empStagingMatchingUpdatePropertiesController.js';
import './shared/components/directives/fadeAnim.js';
import './shared/components/directives/fallbackDirective.js';
import './shared/components/directives/focusDirective.js';
import './shared/components/directives/IAMContactDirective.js';
import './shared/components/directives/iamEventDirective.js';
import './shared/components/directives/iamEventDirectiveEventAndTaskController.js';
import './shared/components/directives/iamEventDirectiveGroupController.js';
import './shared/components/directives/iamEventDirectiveGroupSummaryController.js';
import './shared/components/directives/iamEventDirectiveOnHoldToProcessAccessRequestsPendingController.js';
import './shared/components/directives/iamEventDirectiveSummaryTransferController.js';
import './shared/components/directives/icheckDirective.js';
import './shared/components/directives/inputEnterDirective.js';
import './shared/components/directives/personDirective.js';
import './shared/components/directives/personService.js';
import './shared/components/directives/placeholderDirective.js';
import './shared/components/directives/redirectNewIamDirective.js';
import './shared/components/directives/resizeDirective.js';
import './shared/components/directives/scrollArrowIndicatorDirective.js';
import './shared/components/directives/SelectPersonController.js';
import './shared/components/directives/selectPersonDirective.js';
import './shared/components/directives/selfAccessRequestDecisionDirective.js';
import './shared/components/directives/selfAccessRequestDecisionItemController.js';
import './shared/components/directives/selfAccessRequestDecisionListController.js';
import './shared/components/directives/systemsOwnedDecommissionPermissionsDirective.js';
import './shared/components/directives/systemsOwnershipGroupsDirective.js';
import './shared/components/directives/userRequestDirective.js';
import './shared/components/directives/userRequestFollowupsDirective.js';
import './shared/components/directives/userRequestNotStartedActionsController.js';
import './shared/components/directives/userRequestStartedActionsController.js';
import './shared/components/filters/dateUTCFilter.js';
import './shared/components/filters/filterByMultiTokensFilter.js';
import './shared/components/filters/partitionFilter.js';
import './shared/components/helpers/arrayHelpers.js';
import './shared/components/helpers/mailHelpers.js';
import './shared/components/helpers/staticMessageCtrl.js';
import './shared/components/services/accessReviewService.js';
import './shared/components/services/appParamService.js';
import './shared/components/services/authenticatedUserService.js';
import './shared/components/services/businessProcessService.js';
import './shared/components/services/businessSystemService.js';
import './shared/components/services/employeeService.js';
import './shared/components/services/employeeSyncService.js';
import './shared/components/services/eventService.js';
import './shared/components/services/featureService.js';
import './shared/components/services/languageService.js';
import './shared/components/services/lazyLoadScriptService.js';
import './shared/components/services/lookupService.js';
import './shared/components/services/repositorySystemService.js';
import './shared/components/services/searchService.js';
import './shared/components/services/selfAccessRequestService.js';
import './shared/components/services/supervisorService.js';
import './shared/components/services/systemOwnerReviewService.js';
import './shared/components/services/userAccessRequestService.js';
import './shared/components/showdown/showdown-psptmpl.js';
